import jsonp from '@src/utils/jsonp-util';
import { ZT_ROOT_ADDRESS, PASSPORT_USER_ROOT_ADDRESS } from '@src/constants';
import serviceFactory from './zt';
// const zt = require('./zt');

const services = serviceFactory({ jsonp }, Promise.reject.bind(Promise), ZT_ROOT_ADDRESS);

export default services;



// WEBPACK FOOTER //
// ./src/services/zt/index.js